import { Component } from '@angular/core';
import {Events, IonicPage, Loading, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ApiForumProvider} from "../../providers/api-forum/api-forum";
import {AppForumTopicsPage} from "../app-forum-topics/app-forum-topics";
import {ChatStateProvider} from "../../providers/chat-state/chat-state";
import {AppForumPostsPage} from "../app-forum-posts/app-forum-posts";

/**
 * Generated class for the AppForumListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-forum-list',
  templateUrl: 'app-forum-list.html',
})
export class AppForumListPage {

  private forumList: Array<any>;
  private forumTopicPage: any = AppForumTopicsPage;

  private unreadState: Map<string, number>;

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiForum: ApiForumProvider, public loaderCtrl: LoadingController, public chatState: ChatStateProvider, public events: Events) {
    this.unreadState = new Map<string, number>();
  }



  private loader: Loading;
  ionViewWillLoad() {
    if(!this.forumList) {
      this.loader = this.loaderCtrl.create();
      this.loader.present();
    }

    this.events.subscribe('forum:topicViewedProcessed', () => {
      this.updateForumsState();
    })
  }

  updateForumsState() {
    this.unreadState = new Map<string, number>();

    this.forumList.forEach(row => {
      if(this.chatState.isForumUnread(row.id)) {
        this.unreadState.set(row.id, this.chatState.isForumUnread(row.id));
        console.log(this.unreadState);
      }
    })
  }
  ionViewDidLoad() {
    this.apiForum.getForumList().then(data => {
      this.forumList = data;
      this.loader.dismissAll();

      this.updateForumsState();

      if(this.navParams.get('redirection')) {
        if(this.navParams.get('redirection').forumId) {
          let forum = this.forumList.filter(f => f.id == this.navParams.get('redirection').forumId);
          if (forum.length > 0) {
            this.navCtrl.push(AppForumTopicsPage, {list: forum[0], redirection: this.navParams.get('redirection')})
          }
        }
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-forum-list/app-forum-list.ts